import {
  CHANGE_PASSWORD,
  REQUEST_RESET_PASSWORD,
  CLEAR_RESET_PASSWORD,
  AUTH_TOKEN_KEY,
  API_BASE_URL,
  AUTH_SIGN_IN_POST,
  PROMISE_FULFILLED
} from '../constants/';
import { isGmail, dotRegex } from '../helpers/regex';
import fetch from '../utils/Api';

export const doClearResetPassword = () => ({
  type: CLEAR_RESET_PASSWORD,
  payload: {}
});

export const doResetPassword = ({ email, ...payload }) => {
  if (isGmail(email)) {
    email = `${email.substring(0, email.indexOf('@')).replace(dotRegex, '')}@gmail.com`;
  }
  return {
    type: REQUEST_RESET_PASSWORD,
    payload: fetch().post('/reset/password', { email, ...payload })
      .then(response => response.data)
  }
}

export const doRequestResetPassword = ({ email }) => {
  if (isGmail(email)) {
    email = `${email.substring(0, email.indexOf('@')).replace(dotRegex, '')}@gmail.com`;
  }
  return {
    type: REQUEST_RESET_PASSWORD,
    payload: fetch().post('/reset', { email })
      .then(response => response.data)
  }
}

export const doChangePassword = (payload) => dispatch => {
  return new Promise((resolve, reject) => {
    try {
      const changePasswordResponse = dispatch({
        type: CHANGE_PASSWORD,
        payload: fetch({
          Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
        }).put(`${API_BASE_URL}/auth/password/change`, payload)
          .then(res => res.data)
      });
      changePasswordResponse.then(({ value }) => {
        resolve(dispatch({
          type: `${AUTH_SIGN_IN_POST}${PROMISE_FULFILLED}`,
          payload: value
        }));
      });
    } catch (e) {
      reject(e);
    }
  });
}
